import React, { useEffect } from 'react';
import { Users } from '../components';
import { Button, Group, Stack } from '@mantine/core';

export default function UsersPage({ adding = false, onClose = null }: any) {
    const [open, setOpen] = React.useState<boolean>(false);
    const [updating, setUpdating] = React.useState<any>(null);

    const listRef = React.useRef<any>();

    useEffect(() => {
        if (adding) setOpen(true);
    }, [adding]);

    useEffect(() => {
        if (!open) onClose && onClose();
    }, [open]);

    return <Stack>
        <Group justify='flex-end'>
            <Button onClick={() => setOpen(true)}>Convidar</Button>
        </Group>
        <Users.List ref={listRef} onEdit={(id: string) => setUpdating(id)} />
        <Users.Create
            open={open || updating}
            id={updating}
            onClose={() => { setOpen(false); setUpdating(null) }}
            onSave={() => {
                listRef?.current?.refresh();
                setOpen(false);
                setUpdating(null)
            }}
        />
    </Stack>
}
